import { Component } from "@angular/core";

export const OIDC_ERROR_UNAUTHORIZED_MODAL_NAME = 'oidc-error-unauthorized';

@Component({
    templateUrl: './oidc-error-unauthorized.component.html'
})
export class OidcErrorUnauthorizedComponent { }
